import { AccountTicketsPartialStoreState, ACCOUNT_TICKETS_STATE_KEY } from './account-tickets.reducer';


export const getLoaded = (state: AccountTicketsPartialStoreState) =>
    state[ACCOUNT_TICKETS_STATE_KEY].loaded;

export const getError = (state: AccountTicketsPartialStoreState) =>
    state[ACCOUNT_TICKETS_STATE_KEY].error;


export const getAccountTickets = (state: AccountTicketsPartialStoreState) =>
    state[ACCOUNT_TICKETS_STATE_KEY].allIds.map(id => {
        return state[ACCOUNT_TICKETS_STATE_KEY].byId[id];
    });
export const getAccountEmailTickets = (state: AccountTicketsPartialStoreState) =>
    state[ACCOUNT_TICKETS_STATE_KEY].emailTicketIds.map(id => {
        return state[ACCOUNT_TICKETS_STATE_KEY].byId[id];
    });
export const getAccountVoucherTickets = (state: AccountTicketsPartialStoreState) =>
    state[ACCOUNT_TICKETS_STATE_KEY].voucherTicketIds.map(id => {
        return state[ACCOUNT_TICKETS_STATE_KEY].byId[id];
    });

export const getSelectedTicket = (state: AccountTicketsPartialStoreState) =>
    state[ACCOUNT_TICKETS_STATE_KEY].byId[state[ACCOUNT_TICKETS_STATE_KEY].selectedId];


export const getSelectedRelatedCardTickets = (state: AccountTicketsPartialStoreState) =>
    state[ACCOUNT_TICKETS_STATE_KEY].selectedRelatedCardTicketIds.map(id => {
        return state[ACCOUNT_TICKETS_STATE_KEY].byId[id];
    });
